var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('navbar'),_vm._v(" "),_c('div',{staticClass:"ew-bg-gray"},[_c('section',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col pb-3"},[_c('router-view')],1)])])]),_vm._v(" "),_c('footer-simple',{staticClass:"ew-mar-none"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75c04cba","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard.vue
// module id = null
// module chunks = 